<template>
  <div data-scroll-section class="investmentSolutionsHeader">
    <PageHeaderBackground bottom-gradient>
      <video src="/assets/videos/investments-bg.mp4" type="video/mp4" class="investmentSolutionsHeader_background -desktop" playsinline loop muted autoplay />
      <video src="/assets/videos/investments-bg-mobile.mp4" type="video/mp4" class="investmentSolutionsHeader_background -mobile" playsinline loop muted autoplay />
    </PageHeaderBackground>
    <div v-if="title && lead" class="investmentSolutionsHeader_content">
      <AnimateText tag="h1" appear class="investmentSolutionsHeader_contentHeading typeH2" v-text="title" />
      <FadeIn tag="div" appear :delay="0.5" class="investmentSolutionsHeader_contentText">
        <prismic-rich-text :field="lead" />
      </FadeIn>
    </div>
  </div>
</template>

<script>
import PageHeaderBackground from '@/components/UI/PageHeaderBackground';
import AnimateText from '@/components/Animate/AnimateText';
import FadeIn from '@/components/Animate/FadeIn';
export default {
  name: "InvestmentSolutionsHeader",
  components: {
    PageHeaderBackground,
    AnimateText,
    FadeIn,
  },
  props: {
    title: String,
    lead: Array,
  }
};
</script>

<style lang="stylus">
.investmentSolutionsHeader {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20vh var(--respHorPadding) 0;
}

.investmentSolutionsHeader_background {
  mix-blend-mode: lighten;

  &.-mobile {
    @media (min-width: $breakSm) {
      display: none;  
    }
  }

  &.-desktop {
    @media (max-width: $breakSm) {
      display: none;  
    }
  }
}

.investmentSolutionsHeader_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
}

.investmentSolutionsHeader_contentHeading {
  flex: 0 0 auto;
  width: 45%;
  margin-bottom: 3rem;

  @media (max-width: $breakMd) {
    width: 67%;
    margin-bottom: 1rem;
  }
}

.investmentSolutionsHeader_contentText {
  width: 60ch;
  padding-top: 1em;

  p {
    GradientText();
    display: block;
    margin-bottom: 1.25em;
    font-size: 1.5em;
    line-height: 1.4;

    @media (max-width: $breakMd) {
      font-size: 1.25em;
    }
  }

}
</style>